// extracted by mini-css-extract-plugin
export var fadeIn = "_f5-1";
export var modalContent = "_f5-3";
export var overlay = "_f5-0";
export var popoverContent = "_f5-2";
export var results = "_f5-5";
export var searchInputWrapper = "_f5-4";